// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Loading_wrapper__5NfYd","loading":"Loading_loading__1F1wx"};